import React, { Suspense, lazy } from 'react';
import Loader from './feed/loader';

const TabFeed = lazy(() => import('./TabFeed'));

function TabFeedLazy(props) {
    return (
        <Suspense fallback={<Loader />}>
            <TabFeed {...props} />
        </Suspense>
    );
}

export default TabFeedLazy;
export { TabFeedLazy };



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/tab-feed/TabFeedLazy.jsx